import { Component, OnInit, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
})
export class AuthCallbackComponent implements OnInit {

  private router = inject(Router);
  private oidcSecurityService = inject(OidcSecurityService);
  private userService = inject(UserService);

  ngOnInit(): void {

    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        // No autenticado → login
        this.router.navigate(['/']);
        return;
      }

      // Usuario autenticado → obtenemos datos OIDC
      this.oidcSecurityService.userData$.subscribe(userDataResult => {
        const userData = userDataResult.userData;

        const name =
          userData?.name ||
          userData?.preferred_username ||
          userData?.email ||
          null;

        const document = userData?.id || null;

        this.userService.setUserName(name);
        this.userService.setUserDocument(document);

        if (!document) {
          // Sin documento no podemos resolver roles
          this.router.navigate(['/unauthorized']);
          return;
        }

        // Recuperamos usuario y roles desde backend
        this.userService.getUserByDocument(document).subscribe(user => {
          if (!user || !user.roles || user.roles.length === 0) {
            this.router.navigate(['/unauthorized']);
            return;
          }

          this.userService.setUserRoles(user.roles);

          // DECISIÓN DE RUTA SEGÚN ROLES
          const targetRoute = this.resolveLandingRoute(user.roles);
          this.router.navigate([targetRoute]);
        });
      });
    });
  }

  /**
   * Resuelve la ruta inicial tras login según prioridad de roles
   * 1. CV
   * 2. Ofertas
   * 3. Gestión
   * 4. Unauthorized
   */
  private resolveLandingRoute(roles: string[]): string {

    if (roles.includes('ASESOR_CV') || roles.includes('ADMIN')) {
      return '/curriculum';
    }

    if (roles.includes('GESTOR_OFERTAS') || roles.includes('ADMIN')) {
      return '/job-offers';
    }

    if (roles.includes('USER_ADMIN') || roles.includes('ADMIN')) {
      return '/management';
    }

    return '/unauthorized';
  }
}
